import React, { Component } from "react";
import { Link } from "react-router-dom";

class Jumbotron extends Component {
  render() {
    return (
      <div
        id="jumbotron"
        className="text-center"
        style={{
          height: "600px",
        }}
      >
        <div className="mb-4 pt-5">
          <div>
            <h1 className="display-1">{this.props.heading}</h1>
            <h4 className="display-4">{this.props.subheading}</h4>
            <p>{this.props.paragraph}</p>
            <div className="my-4">
              <Link to={this.props.link}>
                <button className="btn btn-primary btn-lg">
                  {this.props.calltoaction}
                </button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Jumbotron;
